<script setup>
const props = defineProps({
  // for bynder images
  media: {
    type: Object,
    required: false,
  },
  mediaKey: {
    type: String,
    default: 'url',
  },
  animate: {
    type: Boolean,
    default: false,
  },
  parentIsRevealed: {
    type: Boolean,
    default: true,
  },
})

const src = computed(
  () => props.media[props.mediaKey] || props.media.url || props.media.src
)
const aspect = computed(() => props.media.height / props.media.width)

const isInView = ref(false)

function onEnter() {
  isInView.value = true
}
function onExit() {
  isInView.value = false
}

const isActive = ref(false)
watchEffect(() => {
  if (props.animate) {
    if (props.parentIsRevealed && isInView.value) {
      isActive.value = true
    }
    if (!props.parentIsRevealed) {
      isActive.value = false
    }
  } else {
    isActive.value = true
  }
})
</script>

<template>
  <InView
    class="animated-image"
    ref="el"
    :class="{ 'animated-image--active': isActive }"
    @enter="onEnter"
    @exit="onExit"
  >
    <div class="animated-image__mask">
      <img class="animated-image__image" :src="src" alt=""/>
    </div>
    <div
      class="animated-image__spacer"
      :style="{ 'padding-bottom': `${aspect * 100}%` }"
    />
  </InView>
</template>

<style lang="scss">
.animated-image {
  position: relative;
  &__mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform: scale(0.85);
    transform-origin: center;
    overflow: hidden;
    transition: transform 1.7s ease-in-out;
    will-change: transform;
  }
  &__image {
    position: absolute;
    top: 0%;
    left: 0%;
    width: 100%;
    height: 100%;
    transform: scale(1.5);
    transform-origin: center;
    transition: transform 1.7s ease-in-out;
    will-change: transform;
  }
  &__spacer {
    position: relative;
  }

  &--active {
    .animated-image {
      &__mask {
        transform: scale(1);
      }
      &__image {
        transform: scale(1);
      }
    }
  }
}
</style>
